export const normalizeDownloadBaseUrl = (domain, pathPrefix = '', domainOnly = false) => {
  if (typeof domain !== 'string' || !domain.trim()) return null;

  try {
    const input = domain.trim();
    const url = new URL(input.includes('://') ? input : `https://${input}`);
    if (!['http:', 'https:'].includes(url.protocol)
      || url.username || url.password || url.search || url.hash) return null;
    if (domainOnly && url.pathname !== '/') return null;

    if (url.pathname === '/' && pathPrefix) {
      url.pathname = `/${pathPrefix.replace(/^\/+|\/+$/g, '')}`;
    }

    return url.href.replace(/\/+$/, '');
  } catch (error) {
    return null;
  }
};

export const replaceDownloadBaseUrl = (value, originalBase, targetBase) => {
  if (Array.isArray(value)) {
    return value.map((item) => replaceDownloadBaseUrl(item, originalBase, targetBase));
  }
  if (typeof value !== 'string' || !originalBase || !targetBase) return value;

  try {
    const source = new URL(value);
    const original = new URL(originalBase);
    const target = new URL(targetBase);
    const prefix = `${original.pathname.replace(/\/+$/, '')}/`;
    if (source.origin !== original.origin || !source.pathname.startsWith(prefix)) return value;

    target.pathname = `${target.pathname.replace(/\/+$/, '')}/${source.pathname.slice(prefix.length)}`;
    target.search = source.search;
    target.hash = source.hash;
    return target.href;
  } catch (error) {
    return value;
  }
};

export const restoreDownloadSource = (value, backendBase, cdns, pathPrefix) => {
  const values = Array.isArray(value) ? value : [value];
  const first = values.find((item) => typeof item === 'string' && item);
  if (!first) return { value, source: 'backend', customDomain: '' };

  const known = cdns.find((cdn) => replaceDownloadBaseUrl(first, cdn.baseUrl, backendBase) !== first);
  let selection = known ? { source: known.id, customDomain: '', baseUrl: known.baseUrl } : null;

  if (!selection && replaceDownloadBaseUrl(first, backendBase, 'https://download-source.invalid') === first) {
    try {
      const url = new URL(first);
      const baseUrl = normalizeDownloadBaseUrl(url.origin, pathPrefix);
      if (replaceDownloadBaseUrl(first, baseUrl, backendBase) !== first) {
        selection = { source: 'custom', customDomain: url.origin, baseUrl };
      }
    } catch (error) {
      return { value, source: 'backend', customDomain: '' };
    }
  }

  if (!selection) return { value, source: 'backend', customDomain: '' };
  const restored = replaceDownloadBaseUrl(value, selection.baseUrl, backendBase);
  if (values.some((item) => item && replaceDownloadBaseUrl(item, selection.baseUrl, backendBase) === item)) {
    return { value, source: 'backend', customDomain: '' };
  }

  return { value: restored, source: selection.source, customDomain: selection.customDomain };
};
